import { render, staticRenderFns } from "./updateempower.vue?vue&type=template&id=7d83fbbb&scoped=true&"
import script from "./updateempower.vue?vue&type=script&lang=js&"
export * from "./updateempower.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./updateempower.vue?vue&type=style&index=1&id=7d83fbbb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d83fbbb",
  null
  
)

export default component.exports